var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCastAirplay = function SvgIconCastAirplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.146 5.646A.5.5 0 0 1 4.5 5.5h15a.5.5 0 0 1 .5.5v10.5a.5.5 0 0 1-.5.5 1 1 0 1 0 0 2 2.5 2.5 0 0 0 2.5-2.5V6a2.5 2.5 0 0 0-2.5-2.5h-15A2.5 2.5 0 0 0 2 6v10.5A2.5 2.5 0 0 0 4.5 19a1 1 0 1 0 0-2 .5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .146-.354"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.76 14.35a1 1 0 0 0-1.52 0l-4.5 5.25a1 1 0 0 0 .76 1.65h9a1 1 0 0 0 .76-1.65zM12 16.536l2.326 2.713H9.674z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCastAirplay;